import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { NotFound } from '@jcm/design-system';
import Obrigacoes from '../pages/Obrigacoes';
import Usuarios from '../pages/AreaAdm/Usuarios';
import Relatorios from '../pages/Relatorios/relatorioObrigacao';
import Origem from '../pages/AreaAdm/Origem';
import OperacoesEmMassa from '../pages/OperacoesEmMassa';
import RegistrosAtividades from '../pages/AreaAdm/Logs';
import { Permissoes } from '../ts/enums/PermissoesEnum';
import { RotaProtegida } from './rotaProtegida';
import usePermissao from '../hooks';
import ListagemObrigacoesLegais from '../pages/AreaAdm/ListagemObrigacaoLegal';
import Novidades from '../pages/Abrapp/Novidades';

const ModuloObrigacoesAppRoute: React.FC = () => {
	const isConsultorExterno = usePermissao([Permissoes.ConsultorExterno]);

	if (isConsultorExterno) {
		return (
			<Routes>
				<Route
					path='/relatorios'
					element={
						<RotaProtegida permissoesNecessarias={[Permissoes.ConsultorExterno]}>
							<Relatorios />
						</RotaProtegida>
					}
				/>
				<Route path='*' element={<Navigate to='/obrigacoes/relatorios' replace />} />
			</Routes>
		);
	}

	return (
		<Routes>
			<Route path='/listagem' element={<Obrigacoes />} />
			<Route path='/origem' element={<Origem />} />
			<Route path='/operacoes-em-massa' element={<OperacoesEmMassa />} />

			<Route
				path='/listagem-abrapp'
				element={
					<RotaProtegida permissoesNecessarias={[Permissoes.AdministradorSistema]}>
						<ListagemObrigacoesLegais />
					</RotaProtegida>
				}
			/>

			<Route
				path='/usuarios'
				element={
					<RotaProtegida permissoesNecessarias={[Permissoes.AdministradorEmpresa, Permissoes.AdministradorSistema]}>
						<Usuarios />
					</RotaProtegida>
				}
			/>

			<Route
				path='/registros-atividades'
				element={
					<RotaProtegida permissoesNecessarias={[Permissoes.AdministradorEmpresa, Permissoes.AdministradorSistema]}>
						<RegistrosAtividades />
					</RotaProtegida>
				}
			/>

			<Route
				path='/relatorios'
				element={
					<RotaProtegida
						permissoesNecessarias={[
							Permissoes.AdministradorEmpresa,
							Permissoes.AdministradorSistema,
							Permissoes.ConsultorExterno,
						]}
					>
						<Relatorios />
					</RotaProtegida>
				}
			/>

			<Route
				path='/novidades'
				element={
					<RotaProtegida permissoesNecessarias={[Permissoes.AdministradorSistema]}>
						<Novidades />
					</RotaProtegida>
				}
			/>

			<Route path='*' element={<NotFound />} />
		</Routes>
	);
};

export default ModuloObrigacoesAppRoute;
